module.exports = __webpack_public_path__ + "static/media/downarrow.e6e31d67.svg";